import type { PublicBracketScheduleSegment } from "../Api/brackets";
import { formatSegmentEta } from "../PublicBracketsListing/publicBracketScheduleInfo";

export function formatBracketScheduleEta(segment: PublicBracketScheduleSegment, eventTimezone: string, showDayName: boolean): string {
    return formatSegmentEta(
        {
            matNames: [segment.matName],
            etaStart: segment.start,
            etaEnd: segment.end,
            roundMarkerFrom: segment.roundMarkerFrom,
            roundMarkerTo: segment.roundMarkerTo,
        },
        eventTimezone,
        showDayName,
    );
}
